import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'CustomProfile';
const ENDPOINT = `/custom-profiles/`;

@Injectable({
    providedIn: 'root'
})
export class CustomProfileService extends ServiceBase {

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
